import { connect } from 'react-redux';
import * as actions from '../../state/actions';
import { StoreState, Dispatch } from '../../types';

import App from '../../App';

function mapStateToProps(state: StoreState) {
  const { user } = state.user;
  return {
    user,
    doShowRefreshButton: state.showRefreshButton.showRefreshButton,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    showRefreshButton: () => dispatch(actions.showRefreshButton()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
